// 🌐 CONTEXT DE ANÁLISE IA
// Sistema: HEPATO TX RONDÔNIA
// Arquivo: src/modules/ia-analise/context/IAAnaliseContext.tsx

import React, { createContext, useContext, ReactNode } from "react";
import { Paciente } from "../../../types";
import { AnaliseIA, CacheAnalise } from "../types";
import { useIAAnalise } from "../hooks/useIAAnalise";

/**
 * 📋 INTERFACE DO CONTEXT
 */
interface IAAnaliseContextData {
  // Estados
  loading: boolean;
  erro: string | null;
  progresso: string;
  rascunho: string; // B389 (AI_157) — texto da Etapa 1 em fluxo
  analiseAtual: AnaliseIA | null;

  // Funções
  gerarAnalise: (paciente: Paciente) => Promise<AnaliseIA | null>;
  verificarCache: (pacienteId: string) => Promise<CacheAnalise>;
  buscarUltimaAnalise: (pacienteId: string) => Promise<AnaliseIA | null>;
  buscarHistoricoAnalises: (
    pacienteId: string,
    limite?: number
  ) => Promise<AnaliseIA[]>;
}

/**
 * 🎯 CRIAR CONTEXT
 */
const IAAnaliseContext = createContext<IAAnaliseContextData | undefined>(
  undefined
);

/**
 * 🔧 PROVIDER DO CONTEXT
 */
interface IAAnaliseProviderProps {
  children: ReactNode;
}

export function IAAnaliseProvider({ children }: IAAnaliseProviderProps) {
  // Usar o hook
  const iaAnalise = useIAAnalise();

  return (
    <IAAnaliseContext.Provider value={iaAnalise}>
      {children}
    </IAAnaliseContext.Provider>
  );
}

/**
 * 🪝 HOOK PARA USAR O CONTEXT
 *
 * Uso em componentes:
 * const { gerarAnalise, loading, erro } = useIAAnaliseContext();
 */
export function useIAAnaliseContext(): IAAnaliseContextData {
  const context = useContext(IAAnaliseContext);

  if (!context) {
    throw new Error(
      "useIAAnaliseContext deve ser usado dentro de IAAnaliseProvider"
    );
  }

  return context;
}
